import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { FilterParent } from '../../models/filter.model';

// identifier
export const FILTER_PARENT_SLICE_ID = 'filterParent';

interface FilterParentModel {
  parent: FilterParent;
}

// default state
const initialState: FilterParentModel = {
  parent: FilterParent.INTERACTION,
};

//slice
const filterParentSlice = createSlice({
  name: FILTER_PARENT_SLICE_ID,
  initialState,
  reducers: {
    setFilterParent: (state: FilterParentModel, action: PayloadAction<FilterParent>) => {
      state.parent = action.payload;
    },
  },
});

//selectors
export const selectFilterParent = (state: RootState) => state.filterParent.parent;

//actions
export const { setFilterParent } = filterParentSlice.actions;

//reducer
export default filterParentSlice;
